<template>
    <div class="calendar-block">
      <div class="mark-container">
        <div>
            <div>
              <div class="types-block">
                <div class="types-label-bar bg-[#4EAE3B] rounded-[4px]"></div>
                <div class="types-label-text text-end text-[#FFF]">
                  тренувався
                </div>
              </div>
              <div class="types-block">
                <div class="types-label-bar bg-[#F9245A] rounded-[4px]"></div>
                <div class="types-label-text text-end text-[#FFF]">
                  пропустив
                </div>
              </div>
              <div class="types-block">
                <div class="types-label-bar bg-[#DFF726] rounded-[4px]"></div>
                <div class="types-label-text text-end text-[#FFF]">
                  заплановане
                </div>
              </div>
              <div class="types-block">
                <div class="types-label-bar bg-[#3B9BF4] rounded-[4px]"></div>
                <div class="types-label-text text-end text-[#FFF]">
                  вихідний
                </div>
              </div>
            </div>
            <div class="visiting-block relative right-[4px]">
                <div class="visiting-element">
                    <div class="count-plate-label text-[#FFF] text-center">
                        тренувань
                    </div>
                    <div class="count-plate-text text-center bg-[#3B9BF4] text-[#FFF] font-semibold rounded-[4px]">
                        {{ trainingsAttendedList.length + trainingsMissedList.length }}
                    </div>
                </div> 
                <div class="visiting-element relative left-[12px]">
                    <div class="count-plate-label text-[#FFF] text-center">
                        відвідувань
                    </div>
                    <div class="count-plate-text text-center bg-[#F9245A] text-white font-semibold rounded-[4px]">
                        {{ trainingsAttendedList.length }}
                    </div>
                </div>

            </div>
        </div>

      </div>

      <div class="">
        <div class="calendar-header-block">
            <span class="calendar-header-text">ВІДВІДУВАННЯ</span>
        </div>
        <div class="flex justify-center items-center mt-[5px]">
            <button @click="previousMonth" class="ml-[60px] mb-[5px] h-[25px]">
              
              <img src="../../assets/left_arrow.svg" class="arrow-height">
      
            </button>
            <span class="current-month-block">{{ currentMonth.toUpperCase() }} {{ currentYear }}</span>
            <button @click="nextMonth" class="mr-[60px] mb-[5px] h-[25px]">
            
              <img src="../../assets/right_arrow.svg" class="arrow-height">
        
            </button>
        </div>
        <table class="mx-auto w-[97%] ">
                <thead height="5px">
                    <tr class="w-[10%]">
                        <th class="text-[#4EAE3B] w-[10px]">Пн</th>
                        <th class="text-[#4EAE3B] w-[10px]">Вт</th>
                        <th class="text-[#4EAE3B] relative left-[1px] w-[10px]">Ср</th>
                        <th class="text-[#4EAE3B] relative left-[1px] w-[10px]">Чт</th>
                        <th class="text-[#4EAE3B] relative left-[3px] w-[10px]">Пт</th>
                        <th class="text-[#F9245A] relative left-[3px] w-[10px]">Сб</th>
                        <th class="text-[#F9245A] w-[10px]">Нд</th>
                    </tr>
                </thead>
        </table>
        <div class="w-[90%] mx-auto bg-[#4E5568] h-px"></div>
        <div class="flex items-center">
            <table class="mx-auto">
                <tbody class="pt-2" >
                <tr v-for="week in weeks" height="12px">
                    <td 
                    v-for="day in week" 
                    :key="day.id" 
                    class="text-center day-plate-container text-[#1D1D1D] border-transparent"
                    height="1vw" width="1vw"
                    >
                    <div 
                        class="day-plate font-bold text-center align-middle mx-auto "
                        :class="{
                          'bg-transparent' : !day,
                          'bg-[#3B9BF4] pt-[2px]' : day.status != 'mokup' && !isPlaned(day) && !isAttended(day) && !isMissed(day),
                          'bg-[#DFF726] pt-[2px]' : isPlaned(day) && !isAttended(day) && !isMissed(day),
                          'bg-[#F9245A] pt-[2px]' : isMissed(day) && !isAttended(day),
                          'bg-[#4EAE3B] pt-[2px]' : isAttended(day),
                          'opacity-40 border-[1px] border-[#3B9BF4] bg-transparent text-[#3B9BF4] pt-[1px]' : day.status === 'mokup'
                        }"
                    >
                        {{ day.monthDay }}
                    </div>
                    </td>
                </tr>
                <tr v-if="weeks.length < 6" height="20px">
                    <td 
                    class="text-center  border-transparent py-[5px]"
                    height="1vw" width="1vw"
                    >
                    <div 
                        class="day-plate font-bold text-center align-middle mx-auto "
                    >
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
  </template>
  <script>
    import { getWeeksInMonth, addingMatchOfTheDayOfTheWeekAndItsNumberInMonth, addMokups, formatWeeks } from './service/helpers'
    import { getPlanedTrainingsByGroupId } from '../../services/apiRequests'
  
    export default {
      data() {
        return {
          currentMonth: '',
          currentYear: '',
          weeks: [],
  
          mappedDatePlanedTrainings: [],
          mappedDateAttendedTrainings: [],
          mappedDateMissedTrainings: [],
        }
      },
  
      props: {
        groupId: {
          type: String,
          required: true
        },
        trainingsAttendedList: {
          type: Array,
          required: true
        },
        trainingsMissedList: {
          type: Array,
          required: true
        }
      },
  
  
      created() {
        this.currentDate = new Date()
        this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
        this.currentYear = this.currentDate.getFullYear()
        this.weeks = addMokups(formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate))))
        console.log('formattedWeeks -------- ', this.weeks)
      },
  
      async mounted() {
        const planedRes = await getPlanedTrainingsByGroupId(this.groupId)

        this.mappedDatePlanedTrainings = planedRes.data.map(item => {
          const dateObj = new Date(item.date)
          dateObj.setDate(dateObj.getDate())
          return dateObj.toISOString().split('T')[0]
        })

        this.mappedDateAttendedTrainings = this.trainingsAttendedList.map(item => {
          const dateObj = new Date(item)
          dateObj.setDate(dateObj.getDate())
          return dateObj.toISOString().split('T')[0]
        })

        this.mappedDateMissedTrainings = this.trainingsMissedList.map(item => {
          const dateObj = new Date(item)
          dateObj.setDate(dateObj.getDate())
          return dateObj.toISOString().split('T')[0]
        })
      },
  
      methods: {
        previousMonth() {
          this.currentDate = new Date(this.currentYear, this.currentDate.getMonth() - 1)
          this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
          this.currentYear = this.currentDate.getFullYear()
          this.weeks = addMokups(formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate))))
          console.log('formattedWeeks -------- ', this.weeks)
        },
        nextMonth() {
          this.currentDate = new Date(this.currentYear, this.currentDate.getMonth() + 1)
          this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
          this.currentYear = this.currentDate.getFullYear()
          this.weeks = addMokups(formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate))))
          console.log('formattedWeeks -------- ', this.weeks)
        },
        isPlaned(day) {
          return this.mappedDatePlanedTrainings.includes(day?.date?.toISOString().split('T')[0])
        },
        isAttended(day) {
          return this.mappedDateAttendedTrainings.includes(day?.date?.toISOString().split('T')[0])
        },
        isMissed(day) {
          return this.mappedDateMissedTrainings.includes(day?.date?.toISOString().split('T')[0])
        }
      }
    }
  </script>
  
<style lang="scss" scoped>
  @media screen and (max-width: 1500px) {
    .calendar-block {
      @apply flex items-center justify-between w-[500px] select-none;
    }

    .types-label-bar {
      @apply w-[50px] h-[5px];
    }

    .types-label-text {
      @apply text-[13px] ml-[9px] w-[90px];
    }

    .day-plate {
      @apply w-[21px] h-[21px] rounded-[4px] text-[13px];
    }

    .day-plate-container {
      @apply px-[5px] text-[12px] border-[10px];
    }

    .arrow-height {
      @apply h-[30px];
    }

    .count-plate-text {
      @apply text-[14px] w-[50px] py-[8px] px-[2px];
    }

    .count-plate-label {
      @apply text-[12px] mb-[2px];
    }

    .calendar-header-text {
      @apply text-[15px] w-full font-semibold text-start text-[#FFF];
    }

    
    .current-month-block {
      @apply text-[14px] w-full font-medium text-center text-[#FFF];
    }
    
    .calendar-header-block {
      @apply flex justify-center relative top-[-1px] items-center ml-[10px];
    }
    
    .mark-container {
      @apply mt-[40px];
    }

    .types-block {
      @apply flex items-center mb-[5px];
    }

    .visiting-block {
      @apply flex justify-between relative top-[38px];
    }
    
    .visiting-element {
      @apply flex flex-col items-center;
    }
  }

  @media screen and (min-width: 1500px) {
    .calendar-block {
      @apply flex items-center justify-between w-[500px] select-none;
    }

    .types-label-bar {
      @apply w-[50px] h-[5px];
    }

    .types-label-text {
      @apply text-[13px] ml-[9px] w-[90px];
    }

    .day-plate {
      @apply w-[21px] h-[21px] rounded-[4px] text-[13px];
    }

    .day-plate-container {
      @apply px-[5px] text-[12px] border-[10px];
    }

    .arrow-height {
      @apply h-[30px];
    }

    .count-plate-text {
      @apply text-[14px] w-[50px] py-[8px] px-[2px];
    }

    .count-plate-label {
      @apply text-[12px] mb-[2px];
    }

    .calendar-header-text {
      @apply text-[15px] w-full font-semibold text-start text-[#FFF];
    }

    
    .current-month-block {
      @apply text-[14px] w-full font-medium text-center text-[#FFF];
    }
    
    .calendar-header-block {
      @apply flex justify-center relative top-[-1px] items-center ml-[10px];
    }
    
    .mark-container {
      @apply mt-[40px];
    }

    .types-block {
      @apply flex items-center mb-[5px];
    }

    .visiting-block {
      @apply flex justify-between relative top-[38px];
    }
    
    .visiting-element {
      @apply flex flex-col items-center;
    }
  }

</style>